/**
 * Immutable scene graph data structures.
 * Once created, never modified; buildSceneGraph assembles a fresh graph per parse.
 */
/** Wrap a TscnScene's parts in a ParsedScene, without copying them. */
export function tscnSceneToParsedScene(path, nodes, externalResources, internalResources, editableInstances) {
    return {
        path,
        nodes,
        internalResources,
        externalResources,
        ...(editableInstances ? { editableInstances } : {}),
    };
}
/**
 * Assemble the immutable single-scene SceneGraph the renderer consumes: flatten the root
 * scene's inline nodes with full paths and parent links, and freeze the graph, its scenes map
 * and its nodes. The live scene tree (`r3f/liveSceneTree.ts`) composes instances (ADR-0013).
 */
export function buildSceneGraph(rootScene) {
    const flattenedNodes = [];
    function flattenNode(node, parentPath) {
        const nodePath = parentPath ? `${parentPath}/${node.name}` : node.name;
        flattenedNodes.push({
            path: nodePath,
            name: node.name,
            data: node,
            source: rootScene.path,
            parent: parentPath,
        });
        for (const child of node.children) {
            flattenNode(child, nodePath);
        }
    }
    for (const node of rootScene.nodes) {
        flattenNode(node, null);
    }
    return Object.freeze({
        rootScene: rootScene.path,
        scenes: Object.freeze(new Map([[rootScene.path, rootScene]])),
        flattenedNodes: Object.freeze(flattenedNodes),
    });
}
//# sourceMappingURL=SceneGraph.js.map